/**
 * Promo Sales Service
 */

DM.Service.PromoSales = (function (DM) {
    var activePromoSale = DM.Config.ActivePromoSale;
    var promoSalesOptions = null;

    var TYPES = [
        {
            id: 1,
            name: 'Black Friday',
            label: 'BLACK FRIDAY',
            symbol: 'black-friday',
            productsTitle: 'BLACK FRIDAY - kupuj z rabatami'
        },
        {
            id: 2,
            name: 'Dni darmowej dostawy',
            label: '',
            symbol: 'free-delivery',
            productsTitle: 'Kupuj z darmową dostawą',
            showLabelsIcon: true
        },
        {
            id: 3,
            name: 'Walentynki',
            label: '',
            symbol: 'valentines',
            productsTitle: 'Walentynki - kupuj z rabatami',
            showLabelsIcon: true
        },
        {
            id: 4,
            name: 'Nowe Kolekcje',
            label: '',
            symbol: 'new-collection',
            productsTitle: 'Nowe kolekcje',
            showLabelsIcon: true
        },
        {
            id: 5,
            symbol: 'new-collection'
        }
    ];

    if (activePromoSale) {
        promoSalesOptions = Object.assign({},
            activePromoSale,
            {
                isActive: !!activePromoSale.ActivePromoSalesId
            },
            TYPES.filter(function (item) {
                return item.id === activePromoSale.ActivePromoSalesId
            })[0]
        );
    }


    return promoSalesOptions;

})(window.DM);
